'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dKind$0024$0024anon$002445 from "./presto.types$-Credential-Kind$$anon$45.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialKind$$anon$47(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$CredentialKind$$anon$47 as $c_Lpresto_types$CredentialKind$$anon$47 };
$p = $c_Lpresto_types$CredentialKind$$anon$47.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialKind$$anon$47;
/** @constructor */
function $h_Lpresto_types$CredentialKind$$anon$47() {
}
export { $h_Lpresto_types$CredentialKind$$anon$47 as $h_Lpresto_types$CredentialKind$$anon$47 };
$h_Lpresto_types$CredentialKind$$anon$47.prototype = $p;
$p.bN = (function(text) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$CredentialKind$().cwt(text));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.cAM = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it.l());
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bJ = (function(t) {
  return this.cAM(t);
});
var $d_Lpresto_types$CredentialKind$$anon$47 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialKind$$anon$47, "presto.types$CredentialKind$$anon$47", ({
  YU: 1,
  K: 1
}));
export { $d_Lpresto_types$CredentialKind$$anon$47 as $d_Lpresto_types$CredentialKind$$anon$47 };
function $s_Lpresto_types$CredentialKind$__a3__Lpresto_types$CredentialKind() {
  $m_Lpresto_types$CredentialKind$();
  return $t_Lpresto_types$CredentialKind$__a3;
}
export { $s_Lpresto_types$CredentialKind$__a3__Lpresto_types$CredentialKind as $s_Lpresto_types$CredentialKind$__a3__Lpresto_types$CredentialKind };
function $s_Lpresto_types$CredentialKind$__up__Lpresto_types$CredentialKind() {
  $m_Lpresto_types$CredentialKind$();
  return $t_Lpresto_types$CredentialKind$__up;
}
export { $s_Lpresto_types$CredentialKind$__up__Lpresto_types$CredentialKind as $s_Lpresto_types$CredentialKind$__up__Lpresto_types$CredentialKind };
function $s_Lpresto_types$CredentialKind$__cp__Lpresto_types$CredentialKind() {
  $m_Lpresto_types$CredentialKind$();
  return $t_Lpresto_types$CredentialKind$__cp;
}
export { $s_Lpresto_types$CredentialKind$__cp__Lpresto_types$CredentialKind as $s_Lpresto_types$CredentialKind$__cp__Lpresto_types$CredentialKind };
function $s_Lpresto_types$CredentialKind$__upcp__Lpresto_types$CredentialKind() {
  $m_Lpresto_types$CredentialKind$();
  return $t_Lpresto_types$CredentialKind$__upcp;
}
export { $s_Lpresto_types$CredentialKind$__upcp__Lpresto_types$CredentialKind as $s_Lpresto_types$CredentialKind$__upcp__Lpresto_types$CredentialKind };
function $s_Lpresto_types$CredentialKind$__smartpass__Lpresto_types$CredentialKind() {
  $m_Lpresto_types$CredentialKind$();
  return $t_Lpresto_types$CredentialKind$__smartpass;
}
export { $s_Lpresto_types$CredentialKind$__smartpass__Lpresto_types$CredentialKind as $s_Lpresto_types$CredentialKind$__smartpass__Lpresto_types$CredentialKind };
/** @constructor */
function $c_Lpresto_types$CredentialKind$() {
  this.c4B = null;
  this.c4C = false;
  this.c4z = null;
  this.c4A = false;
  this.c4D = null;
  this.c4E = false;
  $n_Lpresto_types$CredentialKind$ = this;
  $t_Lpresto_types$CredentialKind$__a3 = new $j_presto$002etypes$0024$002dCredential$002dKind$0024$0024anon$002445.$c_Lpresto_types$CredentialKind$$anon$45(0, "a3", this);
  $t_Lpresto_types$CredentialKind$__up = new $j_presto$002etypes$0024$002dCredential$002dKind$0024$0024anon$002445.$c_Lpresto_types$CredentialKind$$anon$45(1, "up", this);
  $t_Lpresto_types$CredentialKind$__cp = new $j_presto$002etypes$0024$002dCredential$002dKind$0024$0024anon$002445.$c_Lpresto_types$CredentialKind$$anon$45(2, "cp", this);
  $t_Lpresto_types$CredentialKind$__upcp = new $j_presto$002etypes$0024$002dCredential$002dKind$0024$0024anon$002445.$c_Lpresto_types$CredentialKind$$anon$45(3, "upcp", this);
  $t_Lpresto_types$CredentialKind$__smartpass = new $j_presto$002etypes$0024$002dCredential$002dKind$0024$0024anon$002445.$c_Lpresto_types$CredentialKind$$anon$45(4, "smartpass", this);
  $s_Lpresto_types$CredentialKind$__a3__Lpresto_types$CredentialKind();
  $s_Lpresto_types$CredentialKind$__up__Lpresto_types$CredentialKind();
  $s_Lpresto_types$CredentialKind$__cp__Lpresto_types$CredentialKind();
  $s_Lpresto_types$CredentialKind$__upcp__Lpresto_types$CredentialKind();
  $s_Lpresto_types$CredentialKind$__smartpass__Lpresto_types$CredentialKind();
}
export { $c_Lpresto_types$CredentialKind$ as $c_Lpresto_types$CredentialKind$ };
$p = $c_Lpresto_types$CredentialKind$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialKind$;
/** @constructor */
function $h_Lpresto_types$CredentialKind$() {
}
export { $h_Lpresto_types$CredentialKind$ as $h_Lpresto_types$CredentialKind$ };
$h_Lpresto_types$CredentialKind$.prototype = $p;
$p.cwt = (function(\u03b4name) {
  switch (\u03b4name) {
    case "a3": {
      return $s_Lpresto_types$CredentialKind$__a3__Lpresto_types$CredentialKind();
      break;
    }
    case "up": {
      return $s_Lpresto_types$CredentialKind$__up__Lpresto_types$CredentialKind();
      break;
    }
    case "cp": {
      return $s_Lpresto_types$CredentialKind$__cp__Lpresto_types$CredentialKind();
      break;
    }
    case "upcp": {
      return $s_Lpresto_types$CredentialKind$__upcp__Lpresto_types$CredentialKind();
      break;
    }
    case "smartpass": {
      return $s_Lpresto_types$CredentialKind$__smartpass__Lpresto_types$CredentialKind();
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IllegalArgumentException(), ("enum case not found: " + \u03b4name));
    }
  }
});
$p.SN = (function() {
  if ((!this.c4C)) {
    this.c4B = new $c_Lpresto_types$CredentialKind$$anon$46(this);
    this.c4C = true;
  }
  return this.c4B;
});
$p.cx = (function() {
  if ((!this.c4A)) {
    this.c4z = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$14(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((str) => {
      try {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$CredentialKind$().cwt(str));
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
        if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
        } else {
          throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
        }
      }
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa);
    this.c4A = true;
  }
  return this.c4z;
});
$p.csl = (function() {
  if ((!this.c4E)) {
    this.c4D = new $c_Lpresto_types$CredentialKind$$anon$47(this);
    this.c4E = true;
  }
  return this.c4D;
});
var $d_Lpresto_types$CredentialKind$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialKind$, "presto.types$CredentialKind$", ({
  YR: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_types$CredentialKind$ as $d_Lpresto_types$CredentialKind$ };
var $n_Lpresto_types$CredentialKind$;
function $m_Lpresto_types$CredentialKind$() {
  if ((!$n_Lpresto_types$CredentialKind$)) {
    $n_Lpresto_types$CredentialKind$ = new $c_Lpresto_types$CredentialKind$();
  }
  return $n_Lpresto_types$CredentialKind$;
}
export { $m_Lpresto_types$CredentialKind$ as $m_Lpresto_types$CredentialKind$ };
/** @constructor */
function $c_Lpresto_types$CredentialKind$$anon$46(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$CredentialKind$$anon$46 as $c_Lpresto_types$CredentialKind$$anon$46 };
$p = $c_Lpresto_types$CredentialKind$$anon$46.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialKind$$anon$46;
/** @constructor */
function $h_Lpresto_types$CredentialKind$$anon$46() {
}
export { $h_Lpresto_types$CredentialKind$$anon$46 as $h_Lpresto_types$CredentialKind$$anon$46 };
$h_Lpresto_types$CredentialKind$$anon$46.prototype = $p;
$p.a1 = (function(a) {
  $m_Lpresto_types$CredentialKind$();
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Json$();
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Json$JString(a.l());
});
var $d_Lpresto_types$CredentialKind$$anon$46 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialKind$$anon$46, "presto.types$CredentialKind$$anon$46", ({
  YT: 1,
  a: 1,
  k: 1
}));
export { $d_Lpresto_types$CredentialKind$$anon$46 as $d_Lpresto_types$CredentialKind$$anon$46 };
var $t_Lpresto_types$CredentialKind$__a3 = null;
function $u_Lpresto_types$CredentialKind$__a3(x) {
  $t_Lpresto_types$CredentialKind$__a3 = x;
}
export { $t_Lpresto_types$CredentialKind$__a3 as $t_Lpresto_types$CredentialKind$__a3, $u_Lpresto_types$CredentialKind$__a3 as $u_Lpresto_types$CredentialKind$__a3 };
var $t_Lpresto_types$CredentialKind$__up = null;
function $u_Lpresto_types$CredentialKind$__up(x) {
  $t_Lpresto_types$CredentialKind$__up = x;
}
export { $t_Lpresto_types$CredentialKind$__up as $t_Lpresto_types$CredentialKind$__up, $u_Lpresto_types$CredentialKind$__up as $u_Lpresto_types$CredentialKind$__up };
var $t_Lpresto_types$CredentialKind$__cp = null;
function $u_Lpresto_types$CredentialKind$__cp(x) {
  $t_Lpresto_types$CredentialKind$__cp = x;
}
export { $t_Lpresto_types$CredentialKind$__cp as $t_Lpresto_types$CredentialKind$__cp, $u_Lpresto_types$CredentialKind$__cp as $u_Lpresto_types$CredentialKind$__cp };
var $t_Lpresto_types$CredentialKind$__upcp = null;
function $u_Lpresto_types$CredentialKind$__upcp(x) {
  $t_Lpresto_types$CredentialKind$__upcp = x;
}
export { $t_Lpresto_types$CredentialKind$__upcp as $t_Lpresto_types$CredentialKind$__upcp, $u_Lpresto_types$CredentialKind$__upcp as $u_Lpresto_types$CredentialKind$__upcp };
var $t_Lpresto_types$CredentialKind$__smartpass = null;
function $u_Lpresto_types$CredentialKind$__smartpass(x) {
  $t_Lpresto_types$CredentialKind$__smartpass = x;
}
export { $t_Lpresto_types$CredentialKind$__smartpass as $t_Lpresto_types$CredentialKind$__smartpass, $u_Lpresto_types$CredentialKind$__smartpass as $u_Lpresto_types$CredentialKind$__smartpass };
//# sourceMappingURL=presto.types$-Credential-Kind$.js.map
